/* ImportCapsuleComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./ImportCapsuleRenderer");

class ImportScreenComponent extends EventEmitter {
    constructor(logger, fileFactory) {
        super();
        this._logger = logger;
        this._fileFactory = fileFactory;
        this._renderer = new Renderer(this);
        this._registerListeners();
        this._renderer.render();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    get logger() {
        return this._logger;
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._logger = undefined;
                this._fileFactory = undefined;
                this._renderer = undefined;
            },
            (err) => {
                this._logger.warn({ error: err }, "ImportScreenComponent.shutdown() error.");
            }
        );
    }

    sendCapsuleData(zipFileName, data) {
        // Check the contents of the data
        if (!data["NIBPackages.json"] || !data["NIBPaths.json"] || !data["NIBSystemPackages.json"] || !data["NIBSystemPaths.json"]) {
            this._logger.warn("Missing one or more required NIB*.json files - ImportCapsuleCapsule.sendImportData() error.");
            this._context.reject({
                errorCode: "InvalidPackageFormat",
                errorMsg: "Invalid package file format.",
                errorTitle: "Invalid Format"
            });
        } else {
            this._context.resolve({
                action: "loadCapsule",
                capsuleContent: data,
                capsuleName: zipFileName
            });
        }
    }

    sendCapsuleRawZip(zipFileName, data, file) {
        // Check the contents of the data
        if (!data["NIBPackages.json"] || !data["NIBPaths.json"] || !data["NIBSystemPackages.json"] || !data["NIBSystemPaths.json"]) {
            this._logger.warn("Missing one or more required NIB*.json files - ImportCapsuleCapsule.sendImportData() error.");
            this._context.reject({
                errorCode: "InvalidPackageFormat",
                errorMsg: "Invalid package file format.",
                errorTitle: "Invalid Format"
            });
        } else {
            let pkgInfo = {
                "NIBPackages.json": data["NIBPackages.json"],
                "NIBPaths.json": data["NIBPaths.json"],
                "NIBSystemPackages.json": data["NIBSystemPackages.json"],
                "NIBSystemPaths.json": data["NIBSystemPaths.json"]
            };
            new Promise((resolve, reject) => {
                let reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = (error) => reject(error);
            }).then((base64File) => {
                this._context.resolve({
                    action: "loadRawZipCapsule",
                    pkgInfo: pkgInfo,
                    capsuleName: zipFileName,
                    base64File: base64File
                });
            });
        }
    }

    sendImportError(err) {
        this._context.reject(err);
    }

    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = ImportScreenComponent;
